import React, { useMemo, useState } from 'react'

import { useSchedule } from '../../../../hooks/ScheduleContext'
import { SCHEDULING_DEPARTMENT_STATUS_COLOR } from '../../../../styles/constant'
import { AppointmentsDrawer } from '../../AppointmentsDrawer'

import { Caixa, Grupo, Numero, Ponto } from './styles'

/*
 * Os tres grupos sao os MESMOS que a API ja usa no filtro de status da agenda
 * (ver getServiceOrdersForCalendarBTBatch): "Em andamento" e EM ANDAMENTO ou
 * FINALIZADO — FINALIZADO aqui e o check-in, o pet ja esta na loja — e
 * "Finalizado" e ORÇAMENTO ENVIADO. Se o contador inventasse um agrupamento
 * proprio, filtrar por "Em andamento" devolveria um numero diferente do que o
 * contador mostra, e nenhum dos dois pareceria confiavel.
 *
 * CANCELADO nao aparece porque a API nao manda cancelado para a agenda, entao
 * a soma dos tres fecha com o que esta na tela.
 *
 * PAGO entra em Finalizado: vem depois de ORÇAMENTO ENVIADO no fluxo, e sem
 * isso um atendimento pago sumiria da conta sem explicacao.
 */
const GRUPOS = [
  {
    chave: 'agendado',
    rotulo: 'Agendado',
    cor: 'scheduled',
    status: ['AGENDADO', 'PRE-AGENDADO'],
  },
  {
    chave: 'andamento',
    rotulo: 'Em andamento',
    cor: 'checkIn',
    status: ['EM ANDAMENTO', 'FINALIZADO', 'AGUARDANDO ATENDIMENTO', 'EM ATENDIMENTO'],
  },
  {
    chave: 'finalizado',
    rotulo: 'Finalizado',
    cor: 'checkout',
    status: ['ORÇAMENTO ENVIADO', 'PAGO'],
  },
]

const grupoDoStatus = {}
GRUPOS.forEach((grupo) => {
  grupo.status.forEach((status) => {
    grupoDoStatus[status] = grupo.chave
  })
})

export function StatusSummary({ theme }) {
  const { getSchedules, getConfig } = useSchedule()
  const schedules = getSchedules()
  const config = getConfig()

  const [grupoAberto, setGrupoAberto] = useState(null)

  /*
   * Uma passada so monta a contagem E as listas. O numero e a lista precisam
   * sair do mesmo lugar: se fossem calculados em dois lugares, um ajuste na
   * regra de um nao chegaria no outro e a gaveta mostraria um numero de
   * agendamentos diferente do numero no botao que a abriu.
   */
  const porGrupo = useMemo(() => {
    const vazio = { agendado: [], andamento: [], finalizado: [] }
    const lista = Array.isArray(schedules) ? schedules : []

    return lista.reduce((total, agendamento) => {
      const chave = grupoDoStatus[String(agendamento?.status || '').toUpperCase()]
      if (chave) total[chave].push(agendamento)
      return total
    }, vazio)
  }, [schedules])

  const contagem = {
    agendado: porGrupo.agendado.length,
    andamento: porGrupo.andamento.length,
    finalizado: porGrupo.finalizado.length,
  }

  // as cores sao as MESMAS das bolinhas da grade: o numero e a bolha precisam
  // dizer a mesma coisa, senao a loja tem de traduzir entre as duas
  const paleta =
    SCHEDULING_DEPARTMENT_STATUS_COLOR[theme === 'draMei' ? 'veterinary' : 'petShop']

  return (
    <>
      <Caixa role="group" aria-label="Agendamentos do dia por status">
        {GRUPOS.map((grupo) => (
          /* so bolinha e numero: com o rotulo escrito a caixa crescia demais e
             quebrava a barra de acoes. O nome fica no title, ao passar o mouse. */
          <Grupo
            key={grupo.chave}
            type="button"
            title={
              contagem[grupo.chave]
                ? `Ver os agendamentos: ${grupo.rotulo}`
                : `Nenhum agendamento ${grupo.rotulo.toLowerCase()} no dia`
            }
            disabled={!contagem[grupo.chave]}
            onClick={() => setGrupoAberto(grupo)}
          >
            <Ponto $cor={paleta?.[grupo.cor]} />
            <Numero>{contagem[grupo.chave]}</Numero>
          </Grupo>
        ))}
      </Caixa>

      {!!grupoAberto && (
        <AppointmentsDrawer
          titulo={grupoAberto.rotulo}
          date={config.date}
          theme={theme}
          appointments={porGrupo[grupoAberto.chave]}
          onClose={() => setGrupoAberto(null)}
        />
      )}
    </>
  )
}
